<template>
  <div id="app" style="overflow-x: hidden">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
    <modal
      :show.sync="$store.state.account.modals.subscribe"
      class="modal-default"
      :show-close="false"
      headerClasses="justify-content-center"
      style="padding-top: 100px"
    >
      <p>{{ $t("subscribe_desc") }}</p>
      <fg-input v-model="email" placeholder="Email"></fg-input>
      <template slot="footer">
        <n-button type="danger" @click="closeModal('subscribe')">{{
          $t("CLOSE")
        }}</n-button>
        <n-button type="success" @click="subscribe()">{{
          $t("SUBSCRIBE")
        }}</n-button>
      </template>
    </modal>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 3000;
      "
      v-if="
        $store.state.account.modals.wallet ||
        $store.state.account.modals.alert ||
        $store.state.account.modals.wrongnetwork ||
        $store.state.account.modals.approval || 
        $store.state.account.modals.approvalDST
      "
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="$store.state.account.modals.approval == true"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text-2"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Need to approve LOKA
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 120px;
          width: 90%;
          height: 200px;
        "
      >
        You should confirm to approve LOKA.<br />
        Please wait for the transaction to complete.<br /><br />
        It may take up to ~3 minutes depending on the Ethereum network
        situation.<br /><br />
        This approval process is required only once.
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="$store.state.account.modals.approvalDST == true"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text-2"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Need to approve DST
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 120px;
          width: 90%;
          height: 200px;
        "
      >
        You should confirm to approve DST.<br />
        Please wait for the transaction to complete.<br /><br />
        It may take up to ~3 minutes depending on the Polygon network
        situation.<br /><br />
        This approval process is required only once.
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="$store.state.account.modals.wallet"
      style="
        position: fixed;
        top: calc((100% - 440px) / 2);
        left: calc((100% - 650px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 650px;
        height: 340px;
        background-image: url('/img/1st_sale/pop_wallet.png');
        background-size: 100% 340px;
        z-index: 10000;
      "
    >
      <div
        style="
          position: absolute;
          top: 28px;
          right: 30px;
          width: 40px;
          height: 40px;
          cursor: pointer;
        "
        @click="closeModal('wallet')"
      >
        <img src="/img/event/btn_close.png" />
      </div>
      <h5 style="color: white; font-size: 24px; font-weight: 900">
        {{ $t("connect_wallet") }}
      </h5>
      <div
        style="
          position: absolute;
          top: 120px;
          left: 39px;
          width: 578px;
          height: 107px;
        "
      >
        <img
          src="/img/1st_sale/icon_wallet_1.png"
          style="margin-right: 10px; cursor: pointer"
          @click="connect('metamask')"
        />
        <img
          src="/img/1st_sale/icon_wallet_coin98.png"
          style="margin-right: 10px; cursor: pointer"
          @click="connect('coin98')"
        />
        <img
          src="/img/1st_sale/icon_wallet_2.png"
          style="margin-right: 10px; cursor: pointer"
          @click="connect('walletconnect')"
        />
        <img
          src="/img/1st_sale/icon_wallet_3.png"
          style="margin-right: 10px; cursor: pointer"
          @click="connect('torus')"
        />
        <!-- <img
          src="/img/1st_sale/icon_wallet_4.png"
          style="cursor: pointer;"
          @click="connect('trust')"
        /> -->
      </div>
      <h6
        style="
          position: absolute;
          bottom: 40px;
          color: black;
          font-size: 18px;
          font-weight: 500;
          width: 100%;
          text-align: center;
        "
      >
        {{ $t("info_select_wallet") }}
      </h6>
    </div>
    <div
      v-if="$store.state.account.modals.wrongnetwork"
      style="
        position: fixed;
        top: calc((100% - 358px) / 2);
        left: calc((100% - 600px) / 2);
        text-align: center;
        width: 600px;
        height: 358px;
        border-radius: 10px;
        box-shadow: 0px 10px 10px 0 rgba(0, 0, 0, 0.2);
        border: solid 0 #000;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        style="
          margin-top: 70px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 600;
          line-height: 1.5;
          text-align: center;
          color: #1f2125;
        "
      >
        Current network is not supported.<br />
        Select a network below
      </div>
      <div
        style="
          margin-top: 50px;
          width: 520px;
          margin-left: calc(50% - 260px);
          height: 152px;
        "
      >
        <div
          @click="onClickNetwork('eth')"
          class="wallet-select-frame"
          style="width: 100%; height: 70px; margin-bottom: 12px"
        >
          <img
            src="/img/icon-eth.png"
            style="float: left; margin-left: 20px; margin-top: 15px"
          />
          <div
            style="
              float: left;
              margin-left: 20px;
              margin-top: 20px;
              font-family: Poppins;
              font-size: 18px;
              font-weight: 600;
              letter-spacing: -0.45px;
              text-align: left;
              color: #1f2125;
            "
          >
            ETH
          </div>
          <div
            style="
              float: left;
              margin-left: 10px;
              margin-top: 25px;
              font-family: Poppins;
              font-size: 16px;
              line-height: 1.31;
              text-align: center;
              color: #969aa1;
            "
          >
            - Ethereum
          </div>
          <img src="/img/icon-arrow-on.png" style="float: right; margin-right: 20px; margin-top: 28px;" />
        </div>
        <div
          @click="onClickNetwork('polygon')"
          class="wallet-select-frame"
          style="width: 100%; height: 70px; margin-bottom: 12px"
        >
          <img
            src="/img/icon-matic.png"
            style="float: left; margin-left: 20px; margin-top: 15px"
          />
          <div
            style="
              float: left;
              margin-left: 20px;
              margin-top: 20px;
              font-family: Poppins;
              font-size: 18px;
              font-weight: 600;
              letter-spacing: -0.45px;
              text-align: left;
              color: #1f2125;
            "
          >
            MATIC
          </div>
          <div
            style="
              float: left;
              margin-left: 10px;
              margin-top: 25px;
              font-family: Poppins;
              font-size: 16px;
              line-height: 1.31;
              text-align: center;
              color: #969aa1;
            "
          >
            - Polygon (Matic)
          </div>
          <img src="/img/icon-arrow-on.png" style="float: right; margin-right: 20px; margin-top: 28px;" />
        </div>
      </div>
    </div>
    <div
      v-if="$store.state.account.modals.alert"
      style="
        position: fixed;
        top: calc((100% - 223px) / 2);
        left: calc((100% - 600px) / 2);
        width: 600px;
        height: 223px;
        border-radius: 8px;
        box-shadow: 0px 10px 10px 0 rgba(0, 0, 0, 0.2);
        border: solid 0 #000;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        style="
          position: absolute;
          left: 10%;
          top: 50px;
          width: 80%;
          height: 35px;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: center;
          color: #202431;
        "
      >
        {{
          $store.state.account.alert != null
            ? $store.state.account.alert.content
            : ""
        }}
      </div>
      <img
        src="/img/icon-caution.png"
        style="position: absolute; top: -20px; left: calc(50% - 20px)"
      />
      <div
        @click="closeModal('alert')"
        style="
          position: absolute;
          bottom: 50px;
          left: calc(50% - 80px);
          width: 160px;
          height: 48px;
          padding-top: 11px;
          border-radius: 2px;
          border: solid 0 #000;
          background-color: #13132d;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          font-style: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;
          color: #fff;
          cursor: pointer;
        "
      >
        OK
      </div>
    </div>
  </div>
</template>

<script>
import { Modal, Button, FormGroupInput } from "@/components";
import config from "./config.js";
import axios from "axios";
import { changeNetwork, connectWallet, getNetwork } from "./utils/wallet";

export default {
  components: {
    Modal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    onClickNetwork: async function(network) {
      switch(network) {
        case 'eth':
          await changeNetwork(config.network.eth);
          break;
        case 'polygon':
          await changeNetwork(config.network.polygon);
          break;
        case 'arenaz':
          await changeNetwork(config.network.arenaz);
          break;
      }      
    },
    connect: async function (type) {
      var balance = 0;
      let account = connectWallet(this.$store, type);
      this.closeModal("wallet");
    },
    closeModal: function (modalName) {
      this.$store.commit(`closeModal`, modalName);
    },
    closeAllPopup() {
      this.closeModal("wallet");
      this.closeModal("alert");
      this.closeModal("approval");
      this.closeModal("approvalDST");
    },
    subscribe: async function () {
      let email = this.email.trim();
      if (email.length < 3) {
        alert(this.$t(`alert_invalid_email`));
        return;
      }
      let device = "";
      if (this.$device.mobile) {
        device = "mobile/";
        if (this.$device.android || this.$device.androidPhone) {
          device += "android";
        } else {
          device += "ios";
        }
      } else {
        device = "pc";
      }
      let parameters = JSON.parse(localStorage.parameters);
      let ret = await axios.post(`${config.api.stat_url}/preregist/subscribe`, {
        email: email,
        utm_source: parameters.utm_source,
        utm_medium: parameters.utm_medium,
        ref: parameters.ref,
        device: device,
        language: navigator.language,
        language2: this.$i18n.locale,
        from: "homepage",
      });
      if (ret.data.result == false) {
        alert(this.$t(`alert_${ret.data.err.code}`));
      } else {
        alert(this.$t(`subscribe_ok`));
      }
      this.closeModal("subscribe");
    },
  },
  watch: {
    "$store.state.account.networkId": async function (val) {
      let networkId = await getNetwork();
      console.log("networkId : ", networkId);
      // if (
      //   networkId != config.network.eth &&
      //   networkId != config.network.arenaz &&
      //   networkId != config.network.polygon
      // ) {
      //   this.$store.commit(`openModal`, "wrongnetwork");
      // } else {
      //   this.$store.commit(`closeModal`, "wrongnetwork");
      // }
    },
  },
};
</script>
<style>
.wallet-select-frame {
  width: 520px;
  height: 70px;
  border-radius: 8px;
  border: solid 1px #dfe5ef;
  background-color: #fff;
  cursor: pointer;
}
.wallet-select-frame:hover {
  border-radius: 8px;
  border: solid 2px #06f;
}
</style>  